(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FixationDetailController', FixationDetailController);

    FixationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Fixation', 'Contract', 'Lot'];

    function FixationDetailController($scope, $rootScope, $stateParams, previousState, entity, Fixation, Contract, Lot) {
        var vm = this;

        vm.fixation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:fixationUpdate', function(event, result) {
            vm.fixation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
